import { UseCase } from "../../base";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ProductActivity } from "../../domain/models/product-activity";
import { MasterlocationRepository } from "../../repositories/master-location.repository";


@Injectable({ providedIn: 'root' })
export class GetActivitiesByProductUsecase implements UseCase<string, ProductActivity[]> {

  constructor(private readonly masterlocationRepository: MasterlocationRepository) {
  }

  execute(params: string): Observable<ProductActivity[]> {
    return this.masterlocationRepository.getActivitiesByProduct(params);
  }
}
